import Model from './Model'
import TalentCandidate from "./TalentCandidate";

const LOOKUP = {
    "favorites": -1,
    "past-hires": -2,
    "bring-your-own-talent": -3,
}
export default class TalentPool extends Model
{
	static Key = 'TalentPool';

    static favoritedPoolId = LOOKUP['favorites']
    static pastHiresPoolId = LOOKUP['past-hires']
    static talentInvitesPoolId = LOOKUP['bring-your-own-talent']

    static restrictedPoolNames = [
        'wripple recommended',
        'favorites',
        'past hires',
        'talent invitations'
    ]

    static async createTalentPool(props) {
        const auth = TB.auth().user();

        const createTalentPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${auth.clientOrg().id}/talent-pools/create`), {...props}
        );

        let response = await createTalentPoolRequest.post().catch(e => console.warn(e));

        if (!response || !TB.has(response, 'success.data.client_talent_pool')) {
            return;
        }

        return TalentPool.make(response.success.data.client_talent_pool)
    }

    static async updateTalentPool(talentPoolId, props) {
        const auth = TB.auth().user();

        const updateTalentPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${auth.clientOrg().id}/talent-pools/${talentPoolId}/update`), {...props}
        );

        let response = await updateTalentPoolRequest.post().catch(e => console.warn(e));

        if (!response || !TB.has(response, 'success.data.client_talent_pool')) {
            return;
        }

        return TalentPool.make(response.success.data.client_talent_pool)
    }

    static async deleteTalentPool(talentPoolId, props) {
        const auth = TB.auth().user();

        const deleteTalentPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${auth.clientOrg().id}/talent-pools/${talentPoolId}/delete`), {...props}
        );

        let response = await deleteTalentPoolRequest.post().catch(e => console.warn(e));

        if (!response || !TB.has(response, 'success.data')) {
            return;
        }

        return response.success.data
    }

    static onFavoriteUpdated (talentId, isFavorite) {
        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'searchForTalent' || (queryKey?.[0] === 'fetchTalentPoolDetail');
            }
        }, page => {
            if(!page) return page;
            if (page.users) {
                let users = TB.map([...(page.users || [])], talent => {
                    if (talent.id === talentId) {
                        return TalentCandidate.make({...talent, is_favorite: isFavorite});
                    }
                    return talent;
                });

                return {...page, users}
            }
            if (page.talent_users) {
                let talent_users = TB.map([...(page.talent_users || [])], talent => {

                    if (talent.id === talentId) {

                        return TalentCandidate.make({...talent, is_favorite: isFavorite});
                    }
                    return talent;
                });
                let updatedPage = TalentPool.make({...page, talent_users});

                if (page.id === LOOKUP["favorites"]) {
                    updatedPage.talent_users = TB.filter(talent_users, ['is_favorite', true])

                    updatedPage.total = updatedPage.total + (isFavorite ? 1 : -1);
                    updatedPage.last_page = Math.ceil(updatedPage.total / 12);
                    if (updatedPage.talent_users?.length === 0) {
                        TB.queryClient.invalidateQueries({predicate: ({queryKey}) => (queryKey[0] === 'fetchTalentPoolDetail')});
                    }
                }
                return TalentPool.make(updatedPage)
            }

            return page;
        });
        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                return queryKey?.[0] === 'fetchTalentPools'
            }
        }, pools => {
            if (!pools || !pools?.length) return;

            return TB.map([...pools], pool => {
                if (pool.id === LOOKUP['favorites']) {


                    return this.make({...pool, talent_users_count: (pool.talent_users_count || 0) + (isFavorite ? 1 : -1)})
                }

                return this.make(pool);
            });
        });
    }
    static onTalentUpdated (updatedTalent) {
        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'searchForTalent' || (queryKey?.[0] === 'fetchTalentPoolDetail');
            }
        }, page => {
            if(!page) return page;
            if (page.users) {
                let users = TB.map([...(page.users || [])], talent => {
                    if (talent.id === updatedTalent?.id) {
                        return updatedTalent;
                    }
                    return talent;
                });

                return {...page, users}
            }
            if (page.talent_users) {
                let talent_users = TB.map([...(page.talent_users || [])], talent => {

                    if (talent.id === updatedTalent?.id) {

                        return updatedTalent;
                    }
                    return talent;
                });
                return this.make({...page, talent_users})
            }

            return page;
        });
    }


    static refreshTalentPoolMember (updatedTalent, poolId) {
        TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'searchForTalent' || (queryKey?.[0] === 'fetchTalentPoolDetail' && parseInt(params?.poolId) === parseInt(poolId));
            }
        }, page => {
            if(!page) return page;
            if (page.users) {
                let users = TB.map([...(page.users || [])], talent => {
                    if (talent.id === updatedTalent.id) {
                        return TalentCandidate.make({...talent, ...updatedTalent});
                    }
                    return talent;
                });
                return {...page, users}
            }
            if (page.talent_users) {
                let talent_users = TB.map([...(page.talent_users || [])], talent => {

                    if (talent.id === updatedTalent.id) {

                        return TalentCandidate.make({...talent, ...updatedTalent});
                    }
                    return talent;
                });
                return this.make({...page, talent_users})
            }

            return page;
        });
    }

    static resetTalentMemberDataForPool = async (talentPoolId) => {
        await TB.queryClient.invalidateQueries({predicate: ({queryKey}) => {
            return queryKey[0] === 'fetchTalentPools'
        }})
        return TB.queryClient.invalidateQueries({predicate: ({queryKey}) => {
                return queryKey[0] === 'fetchTalentPoolDetail' && parseInt(queryKey[1]?.poolId) === parseInt(talentPoolId)
            }})
    }

    /*
    * Helper methods
    */
    isWrippleRecommendedPool() {
        return this.name === 'Wripple Recommended'
    }

    isTalentInvitePool() {
        return TB.invert(LOOKUP)[this.id] === 'bring-your-own-talent'
    }
    isFavoritesPool() {
        return TB.invert(LOOKUP)[this.id] === 'past-hires'
    }
    isPastHirePool() {
        return TB.invert(LOOKUP)[this.id] === 'favorites'
    }

    canBeEdited() {
        let auth = TB.auth().user();
        return !this.isFavoritesPool() && !this.isPastHirePool() && (auth?.canManageClients() || !this.isWrippleRecommendedPool())
    }

    canAddRemoveTalent() {
        let auth = TB.auth().user();
        return !this.isFavoritesPool() && !this.isPastHirePool() && (auth?.canManageClients() || !this.isWrippleRecommendedPool())
    }

    isVisible() {
        if (this.is_default) {

            return !this.isWrippleRecommendedPool() || (this.talent_users_count > 0 || this.canAddRemoveTalent());
        }
        return true
    }
}